import { WorldSection } from 'world-section';
import { ProductDrawer } from 'product-drawer';
import { CartDrawer } from 'cart-drawer';
import { initProductForms } from 'product-form';

const cartEl = document.getElementById('CartDrawer');
const productEl = document.getElementById('ProductDrawer');
const cartDrawer = cartEl ? new CartDrawer(cartEl) : null;
const productDrawer = productEl ? new ProductDrawer(productEl) : null;
const openProduct = (p) => productDrawer && productDrawer.open(p);

const worlds = new Map();

function mount(container) {
  const sections = [...container.querySelectorAll('[data-world-section]')];
  if (container.matches?.('[data-world-section]')) sections.unshift(container);
  sections.forEach((el) => {
    if (!worlds.has(el)) worlds.set(el, new WorldSection(el, { openProduct }));
  });
  initProductForms(container);
}

function unmount(container) {
  for (const [el, instance] of worlds) {
    if (container === el || container.contains(el)) {
      instance.destroy();
      worlds.delete(el);
    }
  }
}

mount(document);
document.addEventListener('shopify:section:load', (e) => mount(e.target));
document.addEventListener('shopify:section:unload', (e) => unmount(e.target));

window.OrdiWorld = { worlds, cartDrawer, productDrawer };
